import React from 'react';
import { motion } from 'framer-motion';
import { heroStats, photos } from '../data/site';
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-paper" data-id="element-185" data-mp="ej4nhxerobfg">
      <div className="hairline-grid absolute inset-0" aria-hidden="true" data-id="element-186" data-mp="9ka6n10d0wxz" />
      <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-green/10 blur-[140px]" aria-hidden="true" data-id="element-187" data-mp="4lqj4w64bd3i" />

      <div className="relative mx-auto grid max-w-[1240px] items-center gap-14 px-6 py-20 lg:grid-cols-[1.15fr_0.85fr] lg:py-28" data-id="element-188" data-mp="128phrcgdev41">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-189" data-mp="sbb1bcug66bq">
          <p className="eyebrow text-green-dark" data-id="element-190" data-mp="neazje4mrpqf">Tax · Audit · Finance Consulting</p>
          <h1 className="mt-6 font-display text-[44px] font-medium leading-[1.05] tracking-[-0.01em] text-ink sm:text-[56px] lg:text-[64px]" data-id="element-191" data-mp="3d2tqpg8vwwhp">
            Your final stop for financial clarity,
            <br data-id="element-192" data-mp="3j9ainhg5sy79" />
            <span className="italic text-green-dark" data-id="element-193" data-mp="3j6g1pzwctvil">compliance &amp; growth</span>
          </h1>
          <p className="mt-7 max-w-xl text-[17px] leading-relaxed text-ink-70" data-id="element-194" data-mp="3o5j2371e3dk8">
            Premier Advisory Services Ltd is a full-spectrum tax, audit, accounting
            and finance consulting firm founded in 2014, serving agribusiness, legal
            practices, corporates, government and NGOs, with offices in Nairobi,
            Nanyuki and Nakuru.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-195" data-mp="35aas2493698g">
            <a href="#contact" className="bg-green px-7 py-4 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors hover:bg-green-dark hover:text-white" data-id="element-196" data-mp="2qkmthasahoof">
              Book a Free Consultation
            </a>
            <a href="#services" className="border border-ink/30 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-197" data-mp="2lkqwvwlx8ziw">
              View Our Services
            </a>
          </div>

          <dl className="mt-14 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-line pt-8 sm:grid-cols-4" data-id="element-198" data-mp="n9i2d87l96s0">
            {heroStats.map(stat => <div key={stat.label} data-id="element-199" data-mp="de6munocvvj7">
                <dt className="sr-only" data-id="element-200" data-mp="db2dlbw1a9lo">{stat.label}</dt>
                <dd data-id="element-201" data-mp="1azukfbwjsjwb">
                  <span className="block font-mono text-[26px] leading-none text-green-dark" data-id="element-202" data-mp="1b0dt020b5vxo">
                    {stat.value}
                  </span>
                  <span className="mt-2 block font-mono text-[10px] uppercase tracking-[0.1em] text-ink-50" data-id="element-203" data-mp="112g7vndqwf9a">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.12,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative" data-id="element-204" data-mp="3lu9y13eog2ca">
          <div className="border border-line bg-white p-2" data-id="element-205" data-mp="21awbw4il4jeb">
            <div className="aspect-[4/5] w-full overflow-hidden" data-id="element-206" data-mp="21bfu7mc5d9sv">
              <img src={photos.boardroom} alt="Advisory team reviewing financial reports in a boardroom" className="h-full w-full object-cover" data-id="element-207" data-mp="269r4tza9noc5" />
            </div>
          </div>
          <div className="absolute -bottom-8 left-0 max-w-[19rem] border border-line bg-white p-5 shadow-[0_2px_20px_rgba(11,35,35,0.06)] sm:-left-8" data-id="element-208" data-mp="2fzj1r05u8tjs">
            <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-green-dark" data-id="element-209" data-mp="2ozz4u8io5yo4">
              Est. 2014
            </p>
            <p className="mt-2 text-[13px] leading-relaxed text-ink-70" data-id="element-210" data-mp="2tyaae71xln0j">
              Nairobi-headquartered, serving clients across East Africa&apos;s
              agribusiness and corporate sectors.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}